// /src/api/index.js
import axios from 'axios';
import { auth } from '../firebase';

// Selected by npm script: `npm run dev` (prod api) or `npm run dev:local` (localhost:3001).
// CRA only exposes REACT_APP_* vars - NEXT_PUBLIC_* is a Next.js convention and is always undefined here.
const RAW_BASE = process.env.REACT_APP_API_BASE_URL || 'https://skyquote.co.in/api';

function normalizeBase(url) {
  if (!url) return '';
  let u = url.trim();
  // Collapse accidental "http://http://"
  u = u.replace(/^(https?:\/\/)+/i, (m) => m.split('//')[0] + '//');
  // Remove trailing slash
  u = u.replace(/\/+$/, '');
  return u;
}

const baseURL = normalizeBase(RAW_BASE);

const api = axios.create({
  baseURL,                  // e.g. "http://64.227.151.178/api"
  withCredentials: true,    // if you use cookies; safe to leave on
});

// Guard against passing absolute URLs by mistake and against double slashes
api.interceptors.request.use(
  async (config) => {
    // If someone passes an absolute URL, leave it (axios will ignore baseURL)
    if (!/^https?:\/\//i.test(config.url || '')) {
      // Ensure relative path has no leading slashes so baseURL + '/' + path is clean
      config.url = (config.url || '').replace(/^\/+/, '');
    }

    const user = auth.currentUser;
    if (user) {
      const token = await user.getIdToken();
      config.headers = {
        ...(config.headers || {}),
        Authorization: `Bearer ${token}`,
      };
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Helpful during setup — remove after verifying
// console.log('📡 API baseURL:', api.defaults.baseURL);

export default api;
